// extracted by mini-css-extract-plugin
export var buttons = "modal-module--buttons--0c5b2";
export var close = "modal-module--close--56c88";
export var left = "modal-module--left--52301";
export var modal = "modal-module--modal--179cc";
export var modal__person = "modal-module--modal__person--0e7cb";
export var person = "modal-module--person--f5c75";
export var spin = "modal-module--spin--bd7ce";